import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, {
  getFifteenMinuteSlots,
  getHalfHourSlots,
  getHourSlots,
  getTenMinuteSlots,
  getTwentyMinuteSlots,
} from '../../Constant.js'
import moment from 'moment'
import axios from 'axios'
import Toggle from 'react-toggle'
import { WaveLoading } from 'react-loadingg'

class EventAddTimeslots extends React.Component {
  state = {
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().add(1, 'day').format('YYYY-MM-DD'),

    ten_min_slots: false,
    fifteen_min_slots: false,
    twenty_min_slots: false,
    half_hour_slot: false,
    one_hour_slot: false,
    one_hour_20_min_slot: false,
    one_hour_30_min_slot: false,
    hour_2_slot: false,
    hour_3_slot: false,
    hour_4_slot: false,
    hour_5_slot: false,
    hour_6_slot: false,

    // Break functionality
    include_breaks: false,
    break_duration: 30, // default 30 minutes

    start_time: '',
    end_time: '',
    ticket_count: '',

    is_day_off: true,
    is_requesting: false,

    slots: [
      {
        start_time: '01:00',
        end_time: '02:00',
        ticket_count: 0,
      },
    ],
  }

  componentDidMount() {
    this.eventListData()
  }

  eventListData = async () => {
    var eventId = this.props.event_id
    this.setState({ isloading: true })

    await axios
      .get(Constant.getAPI() + `/event/list-event-timeslots/${eventId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          const matchItem = res.data?.data.filter((itm) => itm.id === this.props.eventTimeslot_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })

            this.setState({ Edit: true })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    // if(
    //     event.target.name == 'start_time' ||
    //     event.target.name == 'end_time' ||
    // ){
    //     this.setState({ [event.target.name]: moment(event.target.value, 'HH:mm').format('HH:mm:ss') })
    // } else {
    this.setState({ [event.target.name]: event.target.value })
    // }
  }

  save = async () => {
    var that = this
    var dateDMY = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY1 = moment(this.state.end_date).format('MM/DD/YYYY')

    this.setState({
      is_requesting: true,
    })

    if (that.props.eventTimeslot_id) {
      var dataEdit = {
        start_time: that.state.start_time,
        end_time: that.state.end_time,
        ticket_count: that.state.ticket_count,
        is_day_off: that.state.is_day_off,
        id: that.props.eventTimeslot_id,
      }

      await axios
        .post(Constant.getAPI() + '/event/edit-event-timeslots', dataEdit, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event timeslots updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/event-timeslots/${that.props.event_id}`
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({
            is_requesting: false,
          })
        })
    } else {
      var data = {
        event_id: that.props.event_id,
        start_date: dateDMY,
        end_date: dateDMY1,
        half_hour_slot:
          that.state.half_hour_slot ||
          that.state.ten_min_slots ||
          that.state.fifteen_min_slots ||
          that.state.twenty_min_slots ||
          that.state.one_hour_slot ||
          that.state.one_hour_20_min_slot ||
          that.state.one_hour_30_min_slot ||
          that.state.hour_2_slot ||
          that.state.hour_3_slot ||
          that.state.hour_4_slot ||
          that.state.hour_5_slot ||
          that.state.hour_6_slot,
        include_breaks: that.state.include_breaks,
        break_duration: that.state.break_duration,
        timeslots: [],
      }

      if (
        that.state.half_hour_slot == true ||
        that.state.ten_min_slots == true ||
        that.state.fifteen_min_slots == true ||
        that.state.twenty_min_slots == true ||
        that.state.one_hour_slot == true ||
        that.state.one_hour_20_min_slot == true ||
        that.state.one_hour_30_min_slot == true ||
        that.state.hour_2_slot == true ||
        that.state.hour_3_slot == true ||
        that.state.hour_4_slot == true ||
        that.state.hour_5_slot == true ||
        that.state.hour_6_slot == true
      ) {
        const startTime = moment(that.state.start_time, 'HH:mm:ss')
        const endTime = moment(that.state.end_time, 'HH:mm:ss')

        let currentTime = moment(startTime)

        if (that.state.one_hour_20_min_slot) {
          while (moment(currentTime).add(80, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(80, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(80, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.one_hour_30_min_slot) {
          while (moment(currentTime).add(90, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(90, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(90, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.one_hour_slot) {
          while (moment(currentTime).add(60, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(60, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(60, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.ten_min_slots) {
          while (moment(currentTime).add(10, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(10, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(10, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.fifteen_min_slots) {
          while (moment(currentTime).add(15, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(15, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(15, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.twenty_min_slots) {
          while (moment(currentTime).add(20, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(20, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(20, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.half_hour_slot) {
          while (moment(currentTime).add(30, 'minutes').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(30, 'minutes').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(30, 'minutes')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.hour_2_slot) {
          while (moment(currentTime).add(2, 'hour').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(2, 'hour').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(2, 'hour')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.hour_3_slot) {
          while (moment(currentTime).add(3, 'hour').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(3, 'hour').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(3, 'hour')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.hour_4_slot) {
          while (moment(currentTime).add(4, 'hour').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(4, 'hour').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(4, 'hour')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.hour_5_slot) {
          while (moment(currentTime).add(5, 'hour').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(5, 'hour').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(5, 'hour')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        } else if (that.state.hour_6_slot) {
          while (moment(currentTime).add(6, 'hour').isSameOrBefore(endTime)) {
            data.timeslots.push({
              start_time: currentTime.format('HH:mm:ss'),
              end_time: moment(currentTime).add(6, 'hour').format('HH:mm:ss'),
              ticket_count: that.state.ticket_count,
            })

            currentTime.add(6, 'hour')

            // Add break time if breaks are enabled
            if (
              that.state.include_breaks &&
              moment(currentTime).add(that.state.break_duration, 'minutes').isSameOrBefore(endTime)
            ) {
              currentTime.add(that.state.break_duration, 'minutes')
            }
          }
        }
      } else {
        let slots = []

        this.state.slots.forEach((itm) => {
          if (itm.start_time && itm.end_time && itm.ticket_count >= 0) {
            slots.push({
              start_time: itm.start_time,
              end_time: itm.end_time,
              ticket_count: itm.ticket_count,
            })
          }
        })

        if (slots.length > 0) {
          data.timeslots = slots
        } else {
          data.timeslots = []
        }
      }

      await axios
        .post(Constant.getAPI() + '/event/add-event-timeslots', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event Timeslots added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/event-timeslots/${that.props.event_id}`
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.messageCode,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({
            is_requesting: false,
          })
        })
    }
  }

  onToggleChange = async (event) => {
    let data = {
      ten_min_slots: false,
      fifteen_min_slots: false,
      twenty_min_slots: false,
      half_hour_slot: false,
      one_hour_slot: false,
      one_hour_20_min_slot: false,
      one_hour_30_min_slot: false,
      hour_2_slot: false,
      hour_3_slot: false,
      hour_4_slot: false,
      hour_5_slot: false,
      hour_6_slot: false,
    }

    this.setState({
      ...data,
      [event.target.name]: !this.state[event.target.name],
    })
  }

  handleChangeSlot = (index, event) => {
    let list = this.state.slots
    list[index][event.target.name] = event.target.value
    this.setState({
      slots: list,
    })
  }

  addTimeSlot = () => {
    this.setState({
      slots: [
        ...this.state.slots,
        {
          start_time: '01:00',
          end_time: '02:00',
          ticket_count: 0,
        },
      ],
    })
  }

  removeSlot = (index) => {
    let list = this.state.slots
    list.splice(index, 1)
    this.setState({
      slots: list,
    })
  }

  render() {
    return (
      <div className="">
        {this.state.is_requesting == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <div className="card-body">
          <div className="row">
            {!this.props.eventTimeslot_id ? (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Start Date</label>
                    <div className="col-sm-9">
                      <input
                        type="date"
                        min={moment().format('YYYY-MM-DD')}
                        id="start_date"
                        name="start_date"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.start_date}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">End Date</label>
                    <div className="col-sm-9">
                      <input
                        min={moment().format('YYYY-MM-DD')}
                        type="date"
                        id="end_date"
                        name="end_date"
                        value={this.state.end_date}
                        className="form-control"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                ></div>

                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 10 Minutes Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.ten_min_slots ? true : false}
                        value={this.state.ten_min_slots}
                        name={'ten_min_slots'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 15 Minutes Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.fifteen_min_slots ? true : false}
                        value={this.state.fifteen_min_slots}
                        name={'fifteen_min_slots'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 20 Minutes Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.twenty_min_slots ? true : false}
                        value={this.state.twenty_min_slots}
                        name={'twenty_min_slots'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create Half Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.half_hour_slot ? true : false}
                        value={this.state.half_hour_slot}
                        name={'half_hour_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 1 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.one_hour_slot ? true : false}
                        value={this.state.one_hour_slot}
                        name={'one_hour_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 1 Hr 20 Min Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.one_hour_20_min_slot ? true : false}
                        value={this.state.one_hour_20_min_slot}
                        name={'one_hour_20_min_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 1 Hr 30 Min Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.one_hour_30_min_slot ? true : false}
                        value={this.state.one_hour_30_min_slot}
                        name={'one_hour_30_min_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 2 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.hour_2_slot ? true : false}
                        value={this.state.hour_2_slot}
                        name={'hour_2_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 3 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.hour_3_slot ? true : false}
                        value={this.state.hour_3_slot}
                        name={'hour_3_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 4 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.hour_4_slot ? true : false}
                        value={this.state.hour_4_slot}
                        name={'hour_4_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 5 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.hour_5_slot ? true : false}
                        value={this.state.hour_5_slot}
                        name={'hour_5_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Create 6 Hour Slots</label>
                    <div className="col-sm-6">
                      <Toggle
                        id={'slot-toggle'}
                        checked={this.state.hour_6_slot ? true : false}
                        value={this.state.hour_6_slot}
                        name={'hour_6_slot'}
                        onChange={this.onToggleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Break Options */}
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginTop: 20, marginBottom: 20 }}
                >
                  <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                    Break Options (Optional)
                    <div style={{ fontSize: 14, fontWeight: 'normal', color: '#666', marginTop: 5 }}>
                      When enabled, breaks will be automatically added between each time slot. This creates non-bookable
                      buffer time between sessions.
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Breaks Between Slots</label>
                    <div className="col-sm-8">
                      <Toggle
                        id={'break-toggle'}
                        checked={this.state.include_breaks ? true : false}
                        value={this.state.include_breaks}
                        name={'include_breaks'}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12"></div>
                {this.state.include_breaks && (
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label">Break Duration</label>
                      <div className="col-sm-8">
                        <select
                          name="break_duration"
                          className="form-control"
                          value={this.state.break_duration}
                          onChange={this.handleChange}
                        >
                          {Constant.getBreakDurationOptions().map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {this.state.half_hour_slot ||
                this.state.ten_min_slots ||
                this.state.fifteen_min_slots ||
                this.state.twenty_min_slots ||
                this.state.one_hour_slot ||
                this.state.one_hour_20_min_slot ||
                this.state.one_hour_30_min_slot ||
                this.state.hour_2_slot ||
                this.state.hour_3_slot ||
                this.state.hour_4_slot ||
                this.state.hour_5_slot ||
                this.state.hour_6_slot ? (
                  <>
                    <div
                      className="col-md-12"
                      style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                    >
                      <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                        Time Slot Range{' '}
                        <span style={{ color: 'red', fontSize: 15 }}>
                          (In this option {this.state.ten_min_slots && '10 Minutes'}
                          {this.state.fifteen_min_slots && '15 Minutes'}
                          {this.state.twenty_min_slots && '20 Minutes'}
                          {this.state.half_hour_slot && 'Half Hour'}
                          {this.state.one_hour_slot && '1 Hour'}
                          {this.state.one_hour_20_min_slot && '1 Hour 20 mins'}
                          {this.state.one_hour_30_min_slot && '1 Hour 30 mins'}
                          {this.state.hour_2_slot && '2 Hour'}
                          {this.state.hour_3_slot && '3 Hour'}
                          {this.state.hour_4_slot && '4 Hour'}
                          {this.state.hour_5_slot && '5 Hour'}
                          {this.state.hour_6_slot && '6 Hour'} slots will be created from Start time to End time.{' '}
                          {this.state.include_breaks &&
                            `${this.state.break_duration} minute breaks will be added between each slot. `}
                          And the ticket count for every slot)
                        </span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Start time</label>
                        <div className="col-sm-9">
                          <select
                            name="start_time"
                            className="form-control"
                            value={this.state.start_time}
                            onChange={this.handleChange}
                          >
                            <option>Select Start time(HH:MM)</option>
                            {this.state.half_hour_slot &&
                              getHalfHourSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.fifteen_min_slots &&
                              getFifteenMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.twenty_min_slots &&
                              getTwentyMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.ten_min_slots &&
                              getTenMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.one_hour_slot ||
                            this.state.one_hour_20_min_slot ||
                            this.state.one_hour_30_min_slot ||
                            this.state.hour_2_slot ||
                            this.state.hour_3_slot ||
                            this.state.hour_4_slot ||
                            this.state.hour_5_slot ||
                            this.state.hour_6_slot
                              ? getHourSlots().map((item) => (
                                  <option
                                    value={item.value}
                                    key={item.value}
                                  >
                                    {item.label}
                                  </option>
                                ))
                              : null}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">End time</label>
                        <div className="col-sm-9">
                          <select
                            name="end_time"
                            className="form-control"
                            value={this.state.end_time}
                            onChange={this.handleChange}
                          >
                            <option>Select Start time(HH:MM)</option>
                            {this.state.half_hour_slot &&
                              getHalfHourSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.fifteen_min_slots &&
                              getFifteenMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.twenty_min_slots &&
                              getTwentyMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.ten_min_slots &&
                              getTenMinuteSlots().map((item) => (
                                <option
                                  value={item.value}
                                  key={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                            {this.state.one_hour_slot ||
                            this.state.one_hour_20_min_slot ||
                            this.state.one_hour_30_min_slot ||
                            this.state.hour_2_slot ||
                            this.state.hour_3_slot ||
                            this.state.hour_4_slot ||
                            this.state.hour_5_slot ||
                            this.state.hour_6_slot
                              ? getHourSlots().map((item) => (
                                  <option
                                    value={item.value}
                                    key={item.value}
                                  >
                                    {item.label}
                                  </option>
                                ))
                              : null}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Ticket Counts</label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            className="form-control"
                            name="ticket_count"
                            id="ticket_count"
                            placeholder="Enter number"
                            onChange={this.handleChange}
                            value={this.state.ticket_count}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="col-md-12"
                      style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                    >
                      <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                        Time Slot
                        <button
                          type="button"
                          className="btn btn-dark btn-round p-1 m-l-10"
                          onClick={this.addTimeSlot}
                        >
                          <i className="f-15 icofont icofont-plus m-0"></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-md-12">
                      {this.state.slots.map((itm, index) => (
                        <div
                          className="row"
                          key={index}
                        >
                          <div className="col-md-1">
                            <div className="form-group row">
                              <label className="col-12 col-form-label">{index + 1}#</label>
                            </div>
                          </div>
                          <div className="col-md-10">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Start time</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="time"
                                      className="form-control"
                                      name="start_time"
                                      id="start_time"
                                      placeholder="Enter number"
                                      onChange={this.handleChangeSlot.bind(this, index)}
                                      value={itm.start_time || ''}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">End time</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="time"
                                      className="form-control"
                                      name="end_time"
                                      id="end_time"
                                      placeholder="Enter number"
                                      onChange={this.handleChangeSlot.bind(this, index)}
                                      value={itm.end_time || ''}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Ticket Counts</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="ticket_count"
                                      id="ticket_count"
                                      placeholder="Enter number"
                                      onChange={this.handleChangeSlot.bind(this, index)}
                                      value={itm.ticket_count}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <button
                              type="button"
                              className="btn btn-danger btn-round p-1 m-l-10"
                              onClick={() => {
                                this.removeSlot(index)
                              }}
                            >
                              <i className="f-15 icofont icofont-minus m-0"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Start time</label>
                    <div className="col-sm-9">
                      <input
                        type="time"
                        className="form-control"
                        name="start_time"
                        id="start_time"
                        placeholder="Enter number"
                        onChange={this.handleChange}
                        value={this.state.start_time}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">End time</label>
                    <div className="col-sm-9">
                      <input
                        type="time"
                        className="form-control"
                        name="end_time"
                        id="end_time"
                        placeholder="Enter number"
                        onChange={this.handleChange}
                        value={this.state.end_time}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Ticket Counts</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        name="ticket_count"
                        id="ticket_count"
                        placeholder="Enter number"
                        onChange={this.handleChange}
                        value={this.state.ticket_count}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Day of </label>
                    <div className="col-sm-9">
                      <select
                        name="is_day_off"
                        className="form-control"
                        value={this.state.is_day_off}
                        onChange={this.handleChange}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="row float-right p-3">
            <button
              onClick={this.save}
              className="btn btn-grd-disabled mr-2"
            >
              <i className="icofont icofont-save"></i>Save
            </button>

            <Link
              to={'/events'}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default EventAddTimeslots
